import * as yup from 'yup';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import { useContactDetailsFormDefinition } from '@gov-nx/core/hooks';
import { useLocale } from '@gov-nx/core/service';
import type { ServiceCode } from '@gov-nx/module/service';
import { RadioBooleanOption } from '@gov-nx/ui/types';
import type { FormDataStep2 } from './context.types';
import type { IFormStep2 } from './form.types';

interface FormStep2Props {
	code: ServiceCode;
	isProcessing: boolean;
	embassyOfficesOptions: { value: string; label: string }[];
}

export const FormStep2 = ({
	code,
	embassyOfficesOptions,
	isProcessing,
}: FormStep2Props): IFormStep2 => {
	const { t } = useLocale(code);

	const contactDetailsFormDefinition = useContactDetailsFormDefinition();
	const formSchema = yup
		.object({
			livesAbroad: yup.string().oneOf(Object.values(RadioBooleanOption)),
			onSpecialList: yup.string().oneOf(Object.values(RadioBooleanOption)),
			...contactDetailsFormDefinition.shape,
			embassyCode: yup.string(),
		})
		.required();

	const formMethods = useGovForm<FormDataStep2>({
		formSchema,
		defaultValues: {
			...contactDetailsFormDefinition.defaultValues,
			livesAbroad: RadioBooleanOption.no,
			onSpecialList: RadioBooleanOption.no,
			embassyCode: '',
		},
	});

	return {
		fields: {
			...contactDetailsFormDefinition.fields(isProcessing, {
				email: {
					label: t('formular.pole.kontakt-email'),
					placeholder: t('formular.placeholder.email'),
				},
				phone: {
					label: t('formular.pole.kontakt-telefon'),
					placeholder: t('formular.placeholder.telefon'),
				},
			}),
			embassy: {
				label: { children: t('formular.pole.misto-zastupitelskehu-uradu') },
				field: {
					name: 'embassyCode',
					isDisabled: isProcessing,
					options: [
						{
							value: '',
							label: t('formular.pole.misto-zastupitelskehu-uradu-zvolte'),
							isDisabled: true,
						},
						...embassyOfficesOptions,
					],
				},
			},
		},
		formDefinition: getFormDefinition({ formMethods, formSchema }),
	};
};
